let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aPuX9")).then(() => parcelRequire('dZLEh'));